<template>
  <div class="wy-interactions-contact-reasons">
    <wy-page-modal ref="pageModal" :onPageClick="handlePageClick">
      <wy-interactions-contact-reasons-detail ref="detailPage" :parent="module" :selectedItem="selectedItem" :clickEvent="clickEvent" />
    </wy-page-modal>

    <wy-interactions-contact-reasons-page-header ref="header" :controller="module" :tableRef="module.$refs.table"/>
    <wy-table-list ref="table" :controller="module" :enableSelection="true" :editPermission="4601" :rowClickEvent="handleRowClick" :handleGenieBotClick="handleGenieBotClick" :defaultSort="{name: 'totalVolumeDMValue', type: 1}" searchFieldName="topicDisplayName" :searchOrFilter="true"/>

    <wy-interactions-contact-reasons-merge-topics ref="mergeTopics" :controller="module" componentName="wy-interactions-contact-reasons" :selectedRows="tableModel.selectedRows"/>
    <wy-interactions-contact-reasons-add-to-existing-topic ref="addToExistingTopic" :controller="module" componentName="wy-interactions-contact-reasons" :selectedRows="tableModel.selectedRows"/>
    <wy-interactions-contact-reasons-update-topic ref="duplicateTopicName" :controller="module" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import WyTableList from '../../widgets/wy-table-list';
import WyInteractionsContactReasonsHeader from './wy-interactions-contact-reasons-page-header'
import WyInteractionsContactReasonsMergeTopics from './wy-interactions-contact-reasons-merge-topics';
import WyInteractionsContactReasonsAddToExistingTopic from './wy-interactions-contact-reasons-add-to-existing-topic';
import WyInteractionsContactReasonsDetail from './wy-interactions-contact-reasons-page-detail';
import wyInteractionsContactReasonsUpdateTopic from './wy-interactions-contact-reasons-update-topic'
import WyPageModal from '../../widgets/wy-page-modal';
import WyUtils from '../../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-interactions-contact-reasons',
  components: { 
    'wy-page-modal': WyPageModal,
    'wy-table-list': WyTableList,
    'wy-interactions-contact-reasons-page-header': WyInteractionsContactReasonsHeader,
    'wy-interactions-contact-reasons-merge-topics': WyInteractionsContactReasonsMergeTopics,
    'wy-interactions-contact-reasons-add-to-existing-topic': WyInteractionsContactReasonsAddToExistingTopic,
    
    'wy-interactions-contact-reasons-detail': WyInteractionsContactReasonsDetail,
    'wy-interactions-contact-reasons-update-topic': wyInteractionsContactReasonsUpdateTopic    
  },
  
  data() {
    return {
      module: this,
      selectedItem: null,
      searchFields: 'topicDisplayName',
      clickEvent: null,
      preMsgObj: null,
      hasGenieBot: false,
      
      columns: [
        {label: "", type:"selection", name: "index", selected: true, sortable: false, mandatory: true, group: 'Selection', minWidth: 30, align:"center", fixed: true},
        {label: "Topic Name", type:"editable", searchHighlight: true, name: "topicDisplayName", mandatory: true, selected: false, sortable: true, group: '', align:"left", minWidth: 350, fixed: true, mainColumn: true, withTotalNumber: true, copyable: false, isEditTopicName: false, extendableField: true, hasInfo: true, disableEditFeature: false, maxCharLength: 50},

        {label: "Total", name: "totalVolumeDMValue", selected: true, sortable: true, sortBy: 'totalVolumeDMValue', group: 'Volume', minWidth: 100, align:"right"},
        {label: "Trend", type: "html", name: "trendGraph", selected: true, sortable: false, group: 'Volume', minWidth: 180},
        {label: "% of total", name: "volumePercent", selected: true, sortable: true, group: 'Volume', sortBy: 'volumePercentNum', minWidth: 120, suffix: "%", align:"right"},
        {label: "% change", type: "percentChange", name: "volumeChangeDisplay", selected: true, sortable: true, sortBy: 'volumeChangeWithoutAbs', group: 'Volume', minWidth: 150, suffix: "%", tooltipMessage: "volumeChangeTooltip", compareWith: 'totalVolumeCompare', noDataSortable: true},

        {label: "Total", name: "avgAutoEvalScoreDisplay", type: 'singleSelect', selected: true, sortable: true, sortBy: 'avgAutoEvalScore', group: 'Auto Evaluation Score', minWidth: 100, align:"right"},
        {label: "% change", type: "percentChange", name: "avgAutoEvalScoreChangeDisplay", selected: true, sortable: true, sortBy: 'avgAutoEvalScoreChangeWithoutAbs', group: 'Auto Evaluation Score', parent: "avgAutoEvalScoreDisplay", minWidth: 150, suffix: "%", tooltipMessage: "avgAutoEvalScoreChangeTooltip", compareWith: 'avgAutoEvalScoreCompareDMValue', noDataSortable: true},

        {label: "Average", name: "avgAgentHandleTimeDisplay", type: 'singleSelect', selected: true, sortable: true, sortBy: 'avgAgentHandleTime', group: 'Call Handle Time', minWidth: 140},
        {label: "% change", type: "percentChange", name: "avgAgentHandleTimeChangeDisplay", selected: true, sortable: true, sortBy: 'avgAgentHandleTimeChangeWithoutAbs', group: 'Call Handle Time', parent: "avgAgentHandleTimeDisplay", minWidth: 150, suffix: "%", tooltipMessage: "avgAgentHandleTimeChangeTooltip", compareWith: 'avgAgentHandleTimeCompareDisplay', noDataSortable: true},
 
        {label: "Average", name: "avgAgentResponseTimeDisplay", type: 'singleSelect', selected: true, sortable: true, sortBy: 'avgAgentResponseTime', group: 'Agent Response Time', minWidth: 140},
        {label: "% change", type: "percentChange", name: "avgAgentResponseTimeChangeDisplay", selected: true, sortable: true, sortBy: 'avgAgentResponseTimeChangeWithoutAbsNum', group: 'Agent Response Time', parent: "avgAgentResponseTimeDisplay", minWidth: 150, suffix: "%", tooltipMessage: "avgAgentResponseTimeChangeTooltip", compareWith: 'avgAgentResponseTimeCompareDisplay', noDataSortable: true},

        {label: "Date", name: "dateFirstFound", selected: true, sortable: true, sortBy: 'dateFirstFoundSorting', group: 'First found', minWidth: 180},
      ],
    }
  },

  computed: {
    ...mapGetters(['authUser', 'isRoleAllow', 'dataModel', 'companyConfig', 'tableModel', 'config', 'dateCompareRange']),

    taskId() {
      return this.dataModel.filters.tasks && this.dataModel.filters.tasks.value && this.dataModel.filters.tasks.value.length === 1 ? this.dataModel.filters.tasks.value[0] : null;
    },
  },

  methods: {
    ...mapMutations(['addDataModelSortings', 'updateDataModelColumns', 'updateDataModelFilter']),
    ...mapActions(['fetchContactReasons', 'saveTopicsToTask', 'mergeInteractionContactReasonsTopics', 'updateTopicName', 'fetchProcessList']),

    refreshTable() {
      this.$refs.table.refreshTable();
    },

    async refreshData() {      
      await this.handleFilterChange({forceRefresh: true, logEvent: false});
      this.$refs.table.refreshTable();      
    },

    handlePageClick(e) {
      if(e.target.innerText != 'Organization' && e.target.innerText != 'All Filters' && this.$refs.detailPage) {
        this.$refs.detailPage.handlePageClick()
      }
    },

    async handleFilterChange(options) {
      this.$root.$emit(`fire-global-filter-change-events`, options);
      if((!this.$router.app.isLoading() && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.$router.app.setLoading(true);
        let isOK = await this.fetchContactReasons(options);        
        if(this.$refs.table) {
          if(isOK) {
            this.updateRenameEditable()
            this.$refs.table.refreshTable();
            let showMsg = false
            this.tableModel.results.forEach(item => {
              if(item.isNew) {
                showMsg = true;
                return false;
              }
            });
            if(showMsg && this.$refs.pageModal && !this.$refs.pageModal.showModal) {
              if(this.preMsgObj == null) {
                this.preMsgObj = this.$message({
                  showClose: true,
                  dangerouslyUseHTMLString: true,
                  message: '<div class="msg-title">New AI-generated topics have been added to your table</div>These topics are automatically created based on recent conversation patterns. You can review them and take action as needed.',
                  customClass: 'interactions-new-topic-notification-message',
                  duration: 8000,
                  type: 'success',
                  iconClass: 'el-icon-new-topic-info',
                  onClose: ()=>{
                      this.preMsgObj = null;
                    }
                });
              }
            }
            // Simulating opening & closing the column selection dropdown, in order to refresh the
            // table so that "% Change" columns hide/show in response to hide/show of "containment" 
            // and "handoffs" column as a result of global filter changes (i.e. "virtual agent 
            // contained", "both virtual & live agents", "live agent only" global filters)
            // if(this.$refs.header.$refs.columnSelectionDropdown) {
            //   this.$refs.header.$refs.columnSelectionDropdown.handleVisibleChange(true);
            //   this.$refs.header.$refs.columnSelectionDropdown.handleVisibleChange(false);
            // }

            let findItem = null;
            if(this.selectedItem && this.tableModel.results && this.tableModel.results.length > 0) {
              this.tableModel.results.forEach(item => {
                if(item.topicDisplayName == this.selectedItem.topicDisplayName) {
                  findItem = item;                
                }
              });
            }   
            
            if(this.$refs.detailPage) {
              this.$refs.detailPage.refreshUI(findItem, options);
            }
            else {
              // this.loading = false;
            }
          }
        }        
        else {
          this.$router.app.setLoading(false);
        }
      }
    },

    updateRenameEditable () {
      this.dataModel.columns.forEach(el => {
        if(el.name == 'topicDisplayName') {
          if(this.taskId) {
            el.disableEditFeature = false;
          }
          else {
            el.disableEditFeature = true;
          }
        }
      });
    },

    async refreshTableData() {
      if(!this.$router.app.isLoading()) {
        this.$router.app.setLoading(true);
        this.$refs.table.clearSelection();
        await this.fetchContactReasons({forceRefresh: true});
        if(this.$refs.table) {      
          this.$refs.table.refreshTable();
        }        
        this.$router.app.setLoading(false);
      }
    },

    handleCompareMetrics() {
      if(this.tableModel.selectedRows) {
        let topics = this.tableModel.selectedRows.map(el => {return {key: el.topicDisplayName, label: el.topicDisplayName, mergedTopics: el.mergedTopics}});
        if(topics && topics.length > 0) {
          let dateRanges = {
            dateRangeA: {
              start: this.dateCompareRange.dateStart,
              end: this.dateCompareRange.dateEnd
            },
            dateRangeB: {
              start: this.dateCompareRange.dateStartCompare,
              end: this.dateCompareRange.dateEndCompare
            }
          }

          setTimeout(() => {
            this.$router.push({ name: 'compareMetrics', params: {dateRanges: dateRanges, topics: topics, whereView: "Results View"}});
          }, 300)
        }
        this.$refs.table.clearSelection();
      }
    },

    handleMergeTopics() {
      this.$refs.mergeTopics.handleMergeTopicsOpen(this.tableModel.selectedRows);
    },

    async handleSaveNewTopic() {
      let topicDisplayNames = this.tableModel.selectedRows.map(el => el.topicDisplayName);
      if(this.taskId) {
        let res = await this.saveTopicsToTask({
          taskId: this.taskId,
          topicList: topicDisplayNames
        })
        // let res = {status: 400}
        if(res && res.status == 200) {
          this.$message({
            showClose: true,
            message: 'All selected topics have been saved here.',
            customClass: 'interactions-save-topics-success-message',
            duration: 5000,
            type: 'success',
            iconClass: 'el-icon-circle-check',
            onClose: ()=>{
                this.preMsgObj = null;
              }
          });
          this.refreshTableData()
        }
        else {
          this.$message({
            showClose: true,
            message: 'Saved topics are failed',
            customClass: 'interactions-save-topics-failed-message',
            duration: 5000,
            type: 'error',
            onClose: ()=>{
                this.preMsgObj = null;
              }
          });
        }
      }
    },

    handleAddToExistingTopic() {
      this.$refs.addToExistingTopic.handleAddToExistingTopicOpen(this.tableModel.selectedRows);
      // this.refreshTableData()
    },

    async updateTableData(row, columnName, newValue, callback) {
      let topicNameObject = {
        oldTopicDisplayName: row[columnName],
        newTopicDisplayName: newValue,
        taskId: this.taskId
      }
      if(topicNameObject.newTopicDisplayName.trim().toLowerCase() == 'others') {
        this.$refs.duplicateTopicName.handleOpen(row, topicNameObject);
        return;
      }
      else {
        this.$router.app.setLoading(true)
        const res = await this.updateTopicName(topicNameObject);

        if(!res) {
          this.$router.app.setLoading(false)
          this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
        }
        else if(res.status == 200) {
          await this.fetchContactReasons({forceRefresh: true});    
          this.$router.app.setLoading(false)

          this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: 'The topic has been successfully renamed <br>"' + topicNameObject.newTopicDisplayName + '"',
            customClass: 'interactions-add-to-existing-topic-success-message',
            duration: 5000,
            type: 'success',
            iconClass: 'el-icon-circle-check',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
          row.topicDisplayName = topicNameObject.newTopicDisplayName;

          this.fetchProcessList();
          if(callback) callback({error: false});

          // update detail page subtitle          
          if(this.$refs.detailPage) {
            this.$refs.detailPage.handleCloseEditTopic();
            this.refreshTableData();
          }
        }
        else if(res.status == 409) {
          this.$router.app.setLoading(false)
          if(callback) callback({error: true});
          
          if(res.data.errorCode == 4013) {
            this.$refs.duplicateTopicName.handleOpen(row, topicNameObject);
          }
          else {
            this.$message({
              showClose: true,
              message: 'The topic is failed to rename',
              customClass: 'interactions-add-to-existing-topic-failed-message',
              duration: 5000,
              type: 'error',
              onClose: ()=>{
                this.preMsgObj = null;
              }
            });
          }        
        }
        else {
          this.$router.app.setLoading(false)
          this.$message({
            showClose: true,
            message: 'The topic is failed to rename',
            customClass: 'interactions-add-to-existing-topic-failed-message',
            duration: 5000,
            type: 'error',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    },

    handleRowClick(rowIndex, item) {
      this.selectedItem = item;
      this.selectedItem.isGenieBot = false;
      this.$root.$el.classList.add("contactReasonDetail");
      this.$refs.table.$el.style.display = "none"
      this.$refs.pageModal.open();   
      if(this.preMsgObj) {
        this.preMsgObj.close();
        this.preMsgObj = null;
      }   
    },

    handleGenieBotClick(rowIndex, item) {
      this.selectedItem = item;
      this.selectedItem.isGenieBot = true;
      this.$root.$el.classList.add("contactReasonDetail");
      this.$refs.table.$el.style.display = "none"
      this.$refs.pageModal.open();   
      if(this.preMsgObj) {
        this.preMsgObj.close();
        this.preMsgObj = null;
      }   
    },

    refreshPage() {
      this.refreshTableData();
    }
  },

  async created() {
    this.$router.currPageComponent = this;
    this.hasGenieBot = WyUtils.hasFeatureFlagEnabled(this.authUser.featureFlags, 'analytics.enable-genie-bot') && this.isRoleAllow([1101, 1102]);

    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]({filterName: event.type});
    })

    // table config
    if(this.config.table != null) {
      let hideColumns = this.config.table.hideColumns;
      if(hideColumns != null && Array.isArray(this.config.table.hideColumns)) {
        this.columns = this.columns.filter(el => !hideColumns.includes(el.group));
      }
    }

    this.columns = this.columns.map(el => {
      return {
        ...el,
        ...(el.name === 'topicDisplayName' && { hasGenieBot: this.hasGenieBot })
      }
    })

    let contactReasonPageConfig = this.companyConfig ? ((this.companyConfig.appPages || {}).interactionsContactReasonPage || {}) : {};
    this.updateDataModelColumns({ columns: this.columns, columnsConfig: contactReasonPageConfig.columns});

    await this.handleFilterChange({forceRefresh: true, logEvent: true});

    if(this.$refs.table) {
      this.$refs.table.finishParentRender = true;
    }
  },

  destroyed() {
    this.dataModel.keyword = '';
    if(this.preMsgObj) {
      this.preMsgObj.close();
      this.preMsgObj = null;
    }
  }
});
</script>

<style lang="scss">
.wy-contactReasonsPage-page {
  font-family: 'Helvetica Neue', sans-serif;
  .total-topic-num{
    color: #4B5158 !important;
  }
  .wy-page-nodata-with-available-date-range {
    margin-top: 2% !important;
    background-color: #FFF !important;
  }
}
.dialogue-content-container {
  line-height: 25px;
  margin-left: 41px;
  .dialogue-content-header {
    display: inline-block;
    width: 87px;
  }
}

.wy-interactions-contact-reasons {
  position: relative;
  min-height: calc(100% - 20px);
  padding-right: 0px;
  margin-bottom: 10px;

  .wy-table-list .wy-table-main thead .wy-header th, .wy-table-list .wy-table-main thead .wy-sub-header th {
    background-color: #F5F8FA !important;
    color: var(--site-font-secondary-color);
    font-size: 14.5px;
    font-weight: 500;
  }
  .wy-table-list thead tr.wy-header > th:first-child, thead tr.wy-sub-header > th:first-child {
    padding-left: 13px;
  }
  .wy-table-list .wy-table-main thead .wy-sub-header th.lastChild {
    text-align: center !important;
  }
  .wy-table-list .wy-table-main thead .wy-sub-header th.lastChild.totalNegativePercent {
    text-align: right !important;
  }
  .wy-table-list .wy-table-main tbody tr td.last-child {
    text-align: center !important;
    div {
      padding-right: 0px;
    }
  }
  .wy-table-list .wy-table-main tbody tr td.totalNegativePercent.last-child {
    text-align: right !important;
    div {
      padding-right: 15px;
    }
  }
  .wy-table-list .wy-table-fixed thead th:nth-last-child(1) {
    font-weight: 500;
    font-size: 14.5px;
  }
  .wy-table-list .wy-table-fixed tbody td:nth-last-child(1) {
    padding-right: 31px;
    padding-left: 0px;
    .el-edit-cancel {
      left: 0px;
    }
  }
  .wy-table-list .wy-table-fixed tbody {
    height: calc(100vh - 381px) !important;
    height: calc(100vh - 421px) !important;
  }
  th.lastChild.fixed.index {
    border-bottom: 1px solid #CAD2DA;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    width: 16px;
    height: 16px;
    border: 1px solid var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
  }
  span.el-checkbox__inner:hover {
    border-radius: 4px;
    font-weight: bolder;
    -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
    box-shadow: var(--primary-checkbox-button-hover-box-shadow);
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    content: '';
    position: absolute;
    display: block;
    background-color: var(--primary-checkbox-button-background-color);
    height: 2px;
    transform: scale(.5);
    left: 0;
    border: 1px solid white;
    right: 0;
    top: 6px;
  }
  .el-checkbox__inner::after {
    border: 2px solid #FFF;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    transition: transform .15s ease-in .05s;
    transform-origin: center;
  }
  .wy-sub-header{
    th.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
      content: "";
      display: inline-block;
      height: 15px;
      background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
      width: 15px;
      position: relative;
      top: 4px;
      left: 7px;
      background-repeat: no-repeat;
    }
  }
  th.sortable.sorted.ascending::after {
    background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
  }
  th.sortable.sorted.descending::after {
    background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
  }
  th.sortable.sorted.ascending:hover::after {
    background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
  }
  th.sortable.sorted.descending:hover::after {
    background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
  }
  th.sortable:hover {
    background-color: #E1E6EC;
    cursor: pointer;
    color: #214586;
    .sort-caret.ascending {
      background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
    }
    .sort-caret.descending {
      background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
    }
  }
  th.sortable:not(.sorted):hover::after {
    background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
  }
  th:not(.sortable) {
    span {
      padding-left: 0;
    }
  }
  .wy-table-list .wy-table-fixed .wy-table-content.wy-has-genie-bot {
    width: 205px !important;
  }
  .wy-table-list .wy-table-fixed .wy-table-content.wy-has-genie-bot.is-new {
    width: 175px !important;
  }
  .wy-table-list .wy-table-fixed .wy-table-content {
    width: 100%;
    font-weight: 500;
    color: #1A55AD;
    border-right: 2px solid transparent!important;
    font-family: 'Helvetica Neue', sans-serif;
    // text-decoration: underline;
  }
  .wy-table-list .wy-table-fixed .wy-table-content.edit {
    position: relative;
    left: -9px;
  }
  .wy-page-modal {
    // min-width: 1079px;
    // overflow-x: auto;
    height: 102%;
    top: -3px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    background-color: #FFF;
    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 3px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFF;
      //border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      // border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  }
  .wy-table-list .wy-table-fixed tbody td:last-child div {
    align-items: center;
  }
  .wy-table-list .wy-table-editor {
    width: 311px;
  }
  .wy-table-list tbody tr td.last-child {
    border-right: 1px solid transparent;
  }
  .wy-table-list .wy-table-main tbody {
    overflow: auto;
    height: calc(100vh - 360px);
    height: calc(100vh - 400px);
    width: calc(100% - 1px);
    max-width: 120%;
    overflow: scroll;
    //: unset;
    &::-webkit-scrollbar {
      width: 20px;
      height: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 180px;
      border: 5px solid transparent;
      border-top: 6px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFF;
      border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  }
  .wy-table-list .wy-table-wrapper {
    width: calc(100% - 2px) !important;
    border: 1px solid #CAD2DA;
    border-top-left-radius: unset;
    border-top-right-radius: unset;
    // border-top: unset;
    overflow: hidden;
    height: calc(100vh - 261px);
    height: calc(100vh - 301px);
    border-radius: 5px;
  }

  // CSS styles related to svg charts generated by Chartist library from the backend
  .ct-area {
    fill-opacity: 0.5;
  }
  .ct-line {
    stroke-width: 1px;
  }
  .ct-series-a .ct-area, .ct-series-a .ct-slice-donut-solid, .ct-series-a .ct-slice-pie {
    fill: #E6E7F8;
  }
  .ct-series-a .ct-bar, .ct-series-a .ct-line, .ct-series-a .ct-point, .ct-series-a .ct-slice-donut {
    stroke: #4D50E8;
  }
  .ct-series-b .ct-area, .ct-series-b .ct-slice-donut-solid, .ct-series-b .ct-slice-pie {
    fill: #E8F1FF;
  }
  .ct-series-b .ct-bar, .ct-series-b .ct-line, .ct-series-b .ct-point, .ct-series-b .ct-slice-donut {
    stroke: #1C4DB2;
  }
  .ct-series-c .ct-area, .ct-series-c .ct-slice-donut-solid, .ct-series-c .ct-slice-pie {
    fill: none;
  }
  .ct-series-c .ct-bar, .ct-series-c .ct-line, .ct-series-c .ct-point, .ct-series-c .ct-slice-donut {
    stroke: black;
    stroke-dasharray: 3px, 3px;
    stroke-width: 0.5px;
  }
}

.line-chart-dropdown {
  box-shadow: 0px 0px 6px #55596A40 !important;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 10px;
  padding-top: 4px;
  padding-bottom: 4px;

  .el-select-dropdown__item.is-disabled {
    > span {
      opacity: 0.5;
    }
  }
}
.interactions-new-topic-notification-message {
    display: flex;
    align-items: flex-start;
    background-color: #EBF9FC;
    border-color: #98C6CD;
    padding: 10px 10px 10px 15px;
    max-width: 634px;

  .msg-title {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 5px;
  }
  .el-message__content {
    font-size: 14px;
    color: #4B5158;
    line-height: 1.5;
    padding-right: 16px;
    padding-left: 10px;
  }
  .el-message__closeBtn.el-icon-close {
    color: #4A4A4F;
    padding-left: 5px;
    position: absolute;
    top: 20px;
    right: 15px;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
  }
  .el-icon-new-topic-info {
    width: 25px;
    height: 25px;
    background-size: 15px;
    background-position-x: 0px;
    background-position-y: 5px;
    background-repeat: no-repeat;
    background-image: url('../../../assets/brands/ia/icons/icon_ia_new_topic_notification_info.svg');
  }
}
.el-message.is-closable.interactions-save-topics-success-message {
  background-color: #D9EEDF;
  border-color: #86D2AE;
  padding: 10px 10px 10px 10px;
  max-width: 300px;
  .el-icon-circle-check {
    color: #186731;
    margin-right: 10px;
    margin-left: 5px;
  }
    .el-message__content {
    color: var(--site-font-secondary-color);
    padding-right: 30px;
    line-height: 1.2;
    font-size: 14px;
    font-weight: 400;
    padding-right: 25px;
  }
  .el-message__closeBtn.el-icon-close {
    color: #4A4A4F;
    border-left: 1px solid #4A4A4F;
    padding-left: 5px;
  }
}
.el-message.is-closable.interactions-add-to-existing-topic-success-message {
    background-color: #D9EEDF;
    border-color: #86D2AE;
    padding: 10px 10px 10px 10px;
    max-width: 300px;
    .el-icon-circle-check {
      color: #186731;
      margin-right: 10px;
      margin-left: 5px;
    }
     .el-message__content {
      color: var(--site-font-secondary-color);
      padding-right: 30px;
      line-height: 1.2;
      font-size: 14px;
      font-weight: 400;
      padding-right: 25px;
    }
    .el-message__closeBtn.el-icon-close {
      color: #4A4A4F;
      border-left: 1px solid #4A4A4F;
      padding-left: 5px;
    }
  }

</style>